<template>
  <b-container class="view-contact">
    <b-row class="view-contact__container">
      <b-col cols="12" lg="7" class="view-contact__title">
        <img
          class="img-fluid"
          src="~assets/components/page-contact/hero-pattern.svg"
          alt=""
        />
        <h1>Contact us</h1>
      </b-col>
      <b-col
        cols="12"
        lg="5"
        class="view-contact__text mt-30 mt-lg-0"
        v-html="bodyText"
      ></b-col>
    </b-row>
  </b-container>
</template>

<script>
import { buildMetaHead } from '@/helpers/meta'

export default {
  name: 'PageContact',
  head() {
    return buildMetaHead({
      title: 'Contact',
      path: this.$route.path,
      description:
        'How can we help? Contact us to learn how to get started, how to post jobs, attract talents and manage applicants in your Applicant Tracking Software.',
      imageUrl: process.env.BASE_URL + '/images/thehub_2022_contact.jpg'
    })
  },
  async asyncData({ $axios, error }) {
    try {
      const { data } = await $axios.get('/pages/contact')
      return {
        bodyText: data.page.content
      }
    } catch (err) {
      error(err)
    }
  }
}
</script>

<style lang="scss">
.view-contact {
  &__container {
    display: flex;
    padding-top: rem(20px);
    padding-bottom: rem(80px);
    align-items: flex-start;

    @include media-breakpoint-up(lg) {
      max-width: 1360px !important;
    }

    @include media-breakpoint-only(md) {
      flex-direction: column !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }

    @include media-breakpoint-down(sm) {
      flex-direction: column !important;
    }
  }

  &__title {
    position: relative;
    background-color: $green;
    text-align: center;
    padding: 25px 50px;

    @include media-breakpoint-only(md) {
      flex: 1 1 auto;
      margin: 0 auto;
    }

    @include media-breakpoint-down(sm) {
      flex: 1 1 auto;
      padding: 20px 25px;
      width: 100%;
      height: auto;
    }

    h1 {
      font-size: 56px;
      text-align: left;
      color: $white;
      position: absolute;
      top: rem(48px);
      left: rem(50px);

      @include media-breakpoint-down(sm) {
        top: rem(31px);
        left: rem(40px);
        font-size: rem(28px);
      }
    }
  }

  &__text {
    padding-left: rem(40px);

    @include media-breakpoint-only(md) {
      margin-left: rem(32px);
    }

    @include media-breakpoint-down(sm) {
      margin-left: 0;
    }

    p {
      padding-bottom: rem(24px);
      font-size: rem(24px);
      max-width: 460px;

      @include media-breakpoint-down(sm) {
        font-size: rem(20px);
      }
    }

    a {
      color: $blue-900;
      font-weight: 500;
    }
  }
}
</style>
